// V_PRIME_PDP_24 | Product gallery Images — winner rollout (Var C - Social proof hero).
// Shown to c-validareOptimized visitors only; c-validareHoldout visitors keep the
// original gallery. Loaded only on the tested product (product-media-gallery.liquid).
(function () {
  'use strict';

  // Social-proof hero (new slide inserted at slot 3, existing slot 3 onward shifts right)
  // Includes: 4.9 star rating, 30-Day Guarantee badge, "Trusted by 18,000+ families" bar
  var SLOT3_IMAGE = {
    src: 'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755',
    srcset: [
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=550 550w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=1100 1100w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=1445 1445w'
    ].join(', '),
    thumbSrcset: [
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=54 54w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=74 74w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=104 104w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=162 162w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=208 208w',
      'https://cdn.shopify.com/s/files/1/0610/1463/8726/files/Frame_1948756376_2_2155b559-1e58-4225-94dc-927bc2c0baf9.webp?v=1791442755&width=416 416w'
    ].join(', '),
    alt: 'Spark Curiosity – 10000 Whys Complete Hardcover Edition, rated 4.9 stars, 30-day guarantee, trusted by 18,000+ families'
  };

  var MEDIA_KEY = 'pdp24-varc';

  // The gallery <img> sits in .product__media inside the modal-opener; the
  // .global-media-settings class is on the wrapper div, not the img itself.
  var MAIN_IMG_SELECTOR = '.product__modal-opener .product__media img';
  // handleExperiments() in c-intelligems-tests.js adds one of these to body once the
  // visitor's holdout bucket is known.
  var OPTIMIZED_CLASS = 'c-validareOptimized';
  var HOLDOUT_CLASS = 'c-validareHoldout';
  var resolved = false;

  // Insert a brand-new slide (main slider + thumbnail + mobile dot) before slotIndex.
  // Clones the existing slide at that slot so markup/classes match the theme, then
  // re-syncs the theme's slider-component so arrows, dots and counters include it.
  function insertGallerySlot(slotIndex, imageData) {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.querySelector('[data-c-pdp24-inserted]')) return;

      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      var slides = gallery.querySelectorAll('.product__media-list .product__media-item');
      var refSlide = slides[slotIndex];
      if (!viewer || !refSlide) return;

      var mediaId = gallery.dataset.section + '-' + MEDIA_KEY;

      // Main slider slide
      var newSlide = refSlide.cloneNode(true);
      newSlide.id = 'Slide-' + mediaId;
      newSlide.dataset.mediaId = mediaId;
      newSlide.dataset.alt = 'always_display';
      newSlide.setAttribute('data-c-pdp24-inserted', '');
      newSlide.classList.remove('is-active', 'hidden');
      // The zoom/modal opener points at the cloned media's id, so drop it rather than
      // open the wrong image in the product modal.
      newSlide.querySelectorAll('.product__media-toggle, .product__media-icon').forEach(function (el) {
        el.remove();
      });
      var img = newSlide.querySelector(MAIN_IMG_SELECTOR);
      if (img) {
        img.src = imageData.src;
        img.srcset = imageData.srcset;
        img.alt = imageData.alt;
        img.removeAttribute('loading');
        img.removeAttribute('id');
      }
      var container = newSlide.querySelector('.product-media-container');
      if (container) {
        // Same 1:1 ratio as the uploaded image, so it never inherits the cloned slide's ratio
        container.style.setProperty('--ratio', '1');
        container.style.setProperty('--preview-ratio', '1');
      }
      refSlide.parentElement.insertBefore(newSlide, refSlide);

      // Thumbnail strip
      var thumbItems = gallery.querySelectorAll('.thumbnail-list .thumbnail-list__item');
      var refThumb = thumbItems[slotIndex];
      if (refThumb) {
        var newThumb = refThumb.cloneNode(true);
        newThumb.id = 'Slide-Thumbnails-' + mediaId;
        newThumb.dataset.target = mediaId;
        newThumb.dataset.alt = 'always_display';
        newThumb.classList.remove('hidden');
        var badge = newThumb.querySelector('.thumbnail__badge');
        if (badge) badge.remove();
        var thumbButton = newThumb.querySelector('button');
        if (thumbButton) {
          thumbButton.removeAttribute('aria-current');
          thumbButton.removeAttribute('aria-describedby');
          // Cloned nodes don't carry listeners, so wire the click the way MediaGallery does
          thumbButton.addEventListener('click', function () {
            gallery.setActiveMedia(mediaId, false);
          });
        }
        var thumbImg = newThumb.querySelector('img');
        if (thumbImg) {
          thumbImg.src = imageData.src;
          thumbImg.srcset = imageData.thumbSrcset;
          thumbImg.alt = imageData.alt;
          thumbImg.removeAttribute('id');
        }
        refThumb.parentElement.insertBefore(newThumb, refThumb);

        gallery.querySelectorAll('.thumbnail-list .thumbnail-list__item').forEach(function (item, i) {
          item.dataset.mediaPosition = i + 1;
        });
      }

      // Mobile pagination dots (only rendered when pagination isn't numeric)
      var dots = viewer.querySelectorAll('.slider-counter__link');
      if (dots.length) {
        var newDot = dots[0].cloneNode(true);
        newDot.classList.remove('slider-counter__link--active', 'hidden');
        newDot.removeAttribute('aria-current');
        newDot.dataset.alt = 'always_display';
        newDot.addEventListener('click', viewer.linkToSlide.bind(viewer));
        var refDot = dots[slotIndex];
        if (refDot) {
          refDot.parentElement.insertBefore(newDot, refDot);
        } else {
          dots[dots.length - 1].parentElement.appendChild(newDot);
        }
        viewer.sliderControlLinksArray = Array.from(viewer.querySelectorAll('.slider-counter__link'));
      }

      // Re-sync both theme sliders with the new slide count
      if (typeof viewer.resetPages === 'function') viewer.resetPages();
      var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (thumbnails && typeof thumbnails.resetPages === 'function') thumbnails.resetPages();
    });
  }

  function tryResolve() {
    var cl = document.body.classList;
    if (resolved || !(cl.contains(OPTIMIZED_CLASS) || cl.contains(HOLDOUT_CLASS))) return false;
    resolved = true;
    // Insert the social-proof hero as a new slide at slot 3 (0-indexed: 2);
    // existing slot 3 onward shifts one place right
    if (cl.contains(OPTIMIZED_CLASS)) insertGallerySlot(2, SLOT3_IMAGE);
    return true;
  }

  // ig:ready can fire before this deferred script runs, so instead of listening for it,
  // check body now and watch for handleExperiments() to mark the visitor's bucket.
  function init() {
    if (tryResolve()) return;
    var observer = new MutationObserver(function () {
      if (tryResolve()) observer.disconnect();
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
